import { render } from "./pagemenu.vue?vue&type=template&id=28419520&scoped=true"
import script from "./pagemenu.vue?vue&type=script&lang=js"
export * from "./pagemenu.vue?vue&type=script&lang=js"

import "./pagemenu.vue?vue&type=style&index=0&id=28419520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28419520"]])

export default __exports__